import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.INIT = function (state, payload) {
  state.rows = payload
}

const state = {
  rows: [],
  row: {},
  condition: {}
}
const actions = {
  init: ({ commit, state }) => {
    let cart = JSON.parse(localStorage.getItem('fs_cart'))
    if (!SysUtils.isEmpty(cart)) commit('INIT', cart)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { search: { api: 'M0002LandingPageService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
